import dayjs from 'dayjs';
export var convertVerifiedAfterToSeconds = function (verified_after) {
    var _a;
    return verified_after
        ? parseInt((_a = dayjs(new Date()))
            .subtract.apply(_a, verified_after).format('X'), 10)
        : undefined;
};
